module.exports = __webpack_public_path__ + "static/media/rich-lace-md.ff32165a.jpg";